import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcChoosePicture = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 124,
	height: 124,
	viewBox: "0 0 124 124",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 120,
			rx: 60,
			fill: "#E9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.1528 93.0454C26.3999 82.8217 37.098 75.8199 49.4425 75.8199H70.1532C82.6166 75.8199 93.4017 82.9572 98.5929 93.3417C89.2794 104.113 75.5327 110.944 60.1891 111C52.8829 110.974 45.9282 109.466 39.6138 106.762C32.4536 103.636 26.15 98.9142 21.1528 93.0454ZM60.3811 68.6087C69.4457 68.6087 76.794 61.309 76.794 52.3043C76.794 43.2997 69.4457 36 60.3811 36C51.3166 36 43.9683 43.2997 43.9683 52.3043C43.9683 61.309 51.3166 68.6087 60.3811 68.6087Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 86,
			y: 86,
			width: 36,
			height: 36,
			rx: 18,
			fill: "#A9AFBB"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 86,
			y: 86,
			width: 36,
			height: 36,
			rx: 18,
			stroke: "white",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M100.512 98.0385C100.9 97.1068 101.81 96.5 102.819 96.5H105.658C106.7 96.5 107.632 97.1464 107.998 98.1222L108.125 98.4593C108.247 98.7845 108.558 99 108.905 99H109.833C111.214 99 112.333 100.119 112.333 101.5V109C112.333 110.381 111.214 111.5 109.833 111.5H98.1667C96.786 111.5 95.6667 110.381 95.6667 109V101.5C95.6667 100.119 96.786 99 98.1667 99H99.5556C99.892 99 100.195 98.7977 100.325 98.4872L100.512 98.0385ZM101.5 104.833C101.5 103.453 102.619 102.333 104 102.333C105.381 102.333 106.5 103.453 106.5 104.833C106.5 106.214 105.381 107.333 104 107.333C102.619 107.333 101.5 106.214 101.5 104.833ZM104 100.667C101.699 100.667 99.8334 102.532 99.8334 104.833C99.8334 107.135 101.699 109 104 109C106.301 109 108.167 107.135 108.167 104.833C108.167 102.532 106.301 100.667 104 100.667Z",
			fill: "white"
		})
	]
});
export default SvgIcChoosePicture;
